
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/snapline.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-snapline-demo-xflow-components-snapline"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/snapline.zh.md?type=demo')
};